import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc, updateDoc, collection, query, where, getDocs, arrayUnion, arrayRemove } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import firebaseConfig from '../config/firebase';

// Inicializar Firebase
console.log('Inicializando Firebase...');

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

console.log('Firebase inicializado com sucesso!');

export { auth, db, storage };

// Funções de autenticação
export const signIn = async (email, password) => {
  try {
    console.log('Tentando fazer login com:', email);
    const result = await signInWithEmailAndPassword(auth, email, password);
    console.log('Login bem-sucedido para:', email);
    return result;
  } catch (error) {
    console.error('Erro durante o login:', error.code, error.message);
    throw error;
  }
};

export const signUp = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const resetPassword = (email) => {
  auth.languageCode = 'pt';
  return sendPasswordResetEmail(auth, email);
};

// Funções do Firestore
export const createUserProfile = async (userId, userData) => {
  const userRef = doc(db, 'users', userId);
  await setDoc(userRef, {
    ...userData,
    createdAt: new Date(),
    habits: [],
    goals: [],
    preferences: {
      theme: 'light',
      colors: {
        primary: '#2196f3',
        secondary: '#f50057',
        background: '#ffffff',
        surface: '#ffffff',
        text: '#000000'
      },
      showDailyQuote: true
    }
  });
};

export const updateUserProfile = async (userId, userData) => {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, userData);
};

export const getUserProfile = async (userId) => {
  const userRef = doc(db, 'users', userId);
  const userSnap = await getDoc(userRef);
  if (userSnap.exists()) {
    return userSnap.data();
  }
  return null;
};

export const updateUserHabits = async (userId, habits) => {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, { habits });
};

export const updateUserGoals = async (userId, goals) => {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, { goals });
};

export const updateUserPreferences = async (userId, preferences) => {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, { preferences });
};

export const isUserAdmin = async (userId) => {
  const userRef = doc(db, 'users', userId);
  const userSnap = await getDoc(userRef);
  
  if (userSnap.exists()) {
    const userData = userSnap.data();
    return userData.role === 'admin';
  }
  
  return false;
};

export const getAllUsers = async () => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef);
  const querySnapshot = await getDocs(q);
  
  const users = [];
  querySnapshot.forEach((doc) => {
    users.push({
      id: doc.id,
      ...doc.data()
    });
  });
  
  return users;
}; 